 
 
import CircularProgress from "@material-ui/core/CircularProgress";

const index = ({}) => {
    return (
        <div className={"loaderContainer"}>
                  <CircularProgress className="loader" />
       </div>
    );
  }
  
  export default index;
  